
import { IPage } from "@/types/ScmTypes";
import { httpRequest } from "../../../utils/HttpRequest";
import { IExternalBillField, IExternalBillSearch, IExternalBillDetail } from "./externalBillType"
class ExternalBillService {
    async page(params: IExternalBillSearch) {
        const apiUrl = "/zzw-vrm/externalRepair/list";
        return await httpRequest.post<IPage<IExternalBillDetail>>(apiUrl, params)
    }
    async one(id: string) {
        const apiUrl = `/zzw-vrm/externalRepair/one/${id}`;
        return await httpRequest.get<IExternalBillField>(apiUrl);
    }
    //导出
    async export(params: IExternalBillSearch) {
        const apiUrl = "/zzw-vrm/externalRepair/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //发布外修报价单
    async externalRepairSend(id: any) {
        const apiUrl = `/zzw-vrm/externalRepair/send/${id}`;
        return await httpRequest.get<IExternalBillField>(apiUrl);
    }
    //报价完成
    async externalRepairEnd(params: any) {
        const apiUrl = "/zzw-vrm/externalRepair/end";
        return await httpRequest.post<IPage<IExternalBillDetail>>(apiUrl, params)
    }
    async submitExternalRepairStatus(val: any) {
        const apiUrl = `/zzw-vrm/externalRepair/approval`;
        return await httpRequest.post<any>(apiUrl, val);
    }
    //完工
    async completeExternalRepair(val: any) {
        const apiUrl = `/zzw-vrm/externalRepair/complete`;
        return await httpRequest.post<any>(apiUrl, val);
    }
    //报价历史
    async getQuoteHistory(val: any) {
        const apiUrl = `/zzw-vrm/externalRepair/send/historyList`;
        return await httpRequest.post<any>(apiUrl, val);
    }
}

export const externalBillService = new ExternalBillService();